import { useEffect, useRef } from "react";

import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import { DocumentEmailTemplateIds, TYPE_OF_DOCUMENTS } from "../EmailTemplates";
import EmailTemplateForm, { EmailTemplateFormHandle } from "@components/forms/EmailTemplateForm";
import { useAdminContext } from "@/hooks/useAdminContext";

const EmailTemplate = () => {
  const params = useParams()
  const { templateId } = params
  const { adminSuscriptionId, adminTenantId, isAdminMode, adminQuerySuffix } = useAdminContext();
  const templateFormRef = useRef<EmailTemplateFormHandle>(null);

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Actualizar Plantilla de Correo"
      backUrl={`/user/email-templates${adminQuerySuffix}`}
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "emailTemplate",
          type: "submit",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: "Reiniciar a plantilla por defecto",
          onClick: () => { templateFormRef.current?.resetToDefault(); }
        }
      ]}
    >
      {templateId && (
        <>
          <h2> Plantillas <b>{TYPE_OF_DOCUMENTS[templateId as DocumentEmailTemplateIds]}</b></h2>
          <EmailTemplateForm
            ref={templateFormRef}
            templateId={templateId as DocumentEmailTemplateIds}
            suscriptionId={isAdminMode ? adminSuscriptionId! : undefined}
            tenantId={isAdminMode ? adminTenantId! : undefined}
          />
        </>
      )}

    </PageContainer>
  );
}

export default EmailTemplate;
